import { TStatusDotIcon } from '@components/StatusDot/StatusDot.interface';
import { TSupplementResponseStatus } from '@interfaces/supplements';

const statusMap = {
  [TSupplementResponseStatus.None]: TStatusDotIcon.Blank,
  [TSupplementResponseStatus.New]: TStatusDotIcon.Blue,
  [TSupplementResponseStatus.Pending]: TStatusDotIcon.Orange,
  [TSupplementResponseStatus.NeedsInfo]: TStatusDotIcon.Yellow,
  [TSupplementResponseStatus.Complete]: TStatusDotIcon.Green,
};

export const getStatusIcon = (value: TSupplementResponseStatus) => statusMap[value];
